// Tiny toast bus. `toast.success/error/info(...)` from anywhere; the <Toaster>
// mounted in the app shell subscribes and renders them.
export interface ToastMsg {
  id: number;
  kind: "success" | "error" | "info";
  text: string;
}

type Listener = (t: ToastMsg) => void;
const listeners = new Set<Listener>();
let counter = 0;

function push(kind: ToastMsg["kind"], text: string): void {
  const msg: ToastMsg = { id: ++counter, kind, text };
  for (const l of listeners) l(msg);
}

export function onToast(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export const toast = {
  success: (text: string) => push("success", text),
  error: (text: string) => push("error", text),
  info: (text: string) => push("info", text),
};

/** Run a mutation and toast a friendly error if it throws. Returns success. */
export async function withToast(
  fn: () => Promise<unknown>,
  successText?: string,
): Promise<boolean> {
  try {
    await fn();
    if (successText) toast.success(successText);
    return true;
  } catch (e) {
    toast.error(e instanceof Error ? e.message : "Something went wrong");
    return false;
  }
}
